// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"fd85b27a","66":"6656511e","688":"c81acc36","892":"0e752e3f","942":"2a6fbacd"}[chunkId] + ".chunk.js";
};